var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item){return _c('v-card',{key:item,staticClass:"loading",attrs:{"min-height":_vm.random(120, 60),"flat":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }